export enum UserTypeConstant {
    Employee = "Employee",
    Consultant = "Consultant",
    Customer = "Customer",
    Lab = "Lab",
    Other = "Other"
}
